import Vue from 'vue'
export default  {
    getIndexHeight (state, h) {    	
    	Vue.set(state, "indexHeight", h.height); 
    	Vue.set(state, "indexTop", h.top);
    },
    setJustAdmit (state, n) {    	
    	Vue.set(state, "JustAdmit", n);     
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js